// © 2025 Camp Promethean, LLC. All Rights Reserved.

export function PhotothermalTooltipContent() {
  return (
    <div className="space-y-2.5 text-xs leading-relaxed">
      <p className="text-sm font-medium">PTR Calculator</p>
      <p>
        Compares daily light energy to the day–night temperature differential (photothermal ratio,
        PTR). Use it to explore vegetative vs generative environmental balance.
      </p>
      <div>
        <p className="font-medium">How to use</p>
        <ol className="mt-1 list-decimal space-y-0.5 pl-4">
          <li>Enter day and night canopy temperatures (°F or °C).</li>
          <li>Enter light intensity (PPFD or mol/m²/d) and photoperiod hours.</li>
          <li>Read the PTR result — it updates automatically as inputs change.</li>
        </ol>
      </div>
      <div>
        <p className="font-medium">Growth tendency slider</p>
        <ul className="mt-1 list-disc space-y-0.5 pl-4">
          <li>Nudge day temp, night temp, or light to model vegetative vs generative targets</li>
          <li>Baseline inputs stay unchanged — sliders show adjusted values only</li>
        </ul>
      </div>
      <p className="text-muted-foreground">
        Higher PTR generally favors generative development; lower values favor vegetative growth.
      </p>
    </div>
  );
}
